import { ReactNode } from 'react';

import { attachComponentData } from '@backstage/core-plugin-api';

import {
  PAGE_CONTENT_SIDEBAR_LEFT_KEY,
  PAGE_CONTENT_SIDEBAR_RIGHT_KEY,
} from './composition';

export type PageContentSideBarProps = { children: ReactNode };

export const ContentSideBarLeft = (_props: PageContentSideBarProps) => null;

attachComponentData(ContentSideBarLeft, PAGE_CONTENT_SIDEBAR_LEFT_KEY, true);

export const ContentSideBarRight = (_props: PageContentSideBarProps) => null;

attachComponentData(ContentSideBarRight, PAGE_CONTENT_SIDEBAR_RIGHT_KEY, true);
